export enum SiteStatus {
    Suspended = 0,
    Activated = 1
}

export function translateSiteStatus(status: SiteStatus): string {
    switch (status) {
        case SiteStatus.Suspended:
            return 'Suspended';
        case SiteStatus.Activated:
            return 'Activated';
        default:
            return status;
    }
}
